export default __webpack_public_path__ + "static/media/busd.84069b9e.svg";